<template>
  <v-fab-transition>
    <div v-show="visible" class="scroll-top-wrapper" :style="wrapperStyle" aria-hidden="false">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            fab
            :small="btnSmall"
            :large="btnLarge"
            :height="btnDimension"
            :width="btnDimension"
            :color="color"
            elevation="6"
            @click="goTop"
            :aria-label="ariaLabel"
          >
            <v-icon :color="iconColor">{{ icon }}</v-icon>
          </v-btn>
        </template>
        <span>{{ tooltip }}</span>
      </v-tooltip>
    </div>
  </v-fab-transition>
</template>

<script>
export default {
  name: "ScrollTop",
  props: {
    threshold: { type: Number, default: 200 }, // mostra após X pixels
    bottom: { type: [Number, String], default: 24 }, // distância do fundo (px)
    right: { type: [Number, String], default: 24 }, // distância da direita (px)
    color: { type: String, default: "primary" },
    icon: { type: String, default: "mdi-chevron-up" },
    iconColor: { type: String, default: "white" },
    tooltip: { type: String, default: "Topo" },
    ariaLabel: { type: String, default: "Voltar ao topo" },
    small: { type: Boolean, default: false }, // se true usa botão pequeno
    size: { type: [Number, String], default: null }, // dimensão fixa em px (ignora small/large)
    smooth: { type: Boolean, default: true }, // scroll suave
  },
  data() {
    return {
      visible: false,
      ticking: false,
    };
  },
  computed: {
    btnSmall() {
      return this.size ? false : this.small;
    },
    btnLarge() {
      return this.size ? false : !this.small;
    },
    btnDimension() {
      return this.size ? `${this.size}px` : undefined;
    },
    wrapperStyle() {
      return {
        position: "fixed",
        right: `${this.right}px`,
        bottom: `${this.bottom}px`,
        "z-index": 1000,
      };
    },
  },
  mounted() {
    // faz bind no window scroll
    window.addEventListener("scroll", this.onScroll, { passive: true });
    // checa inicialmente (caso a página já esteja scrolada)
    this.visible = window.pageYOffset > this.threshold;
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.visible = window.pageYOffset > this.threshold;
        this.ticking = false;
      });
    },
    goTop() {
      if (this.smooth && "scrollBehavior" in document.documentElement.style) {
        window.scrollTo({ top: 0, behavior: "smooth" });
      } else {
        let pos = window.pageYOffset;
        const step = Math.ceil(pos / 4);
        const timer = setInterval(() => {
          pos -= step;
          if (pos <= 0) {
            window.scrollTo(0, 0);
            clearInterval(timer);
          } else {
            window.scrollTo(0, pos);
          }
        }, 3);
      }
      this.$emit("clicked");
    },
  },
};
</script>

<style scoped>
.scroll-top-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
